import { Component, Inject, forwardRef } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TagService } from "../../tags/tag.service";
import { ErrorUtility } from "../../../utility/error-utility";
import { ErrorMessages } from "../../../common/constants";
import { CustomLabelService } from "../../../service/custom-label.service";
import { LocalizationPipe } from "../../pipe";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ContextService } from "../../../service/context.service";

@Component({
    selector: 'add-tag-dialog',
    template: require('./add-tag-dialog.component.html'),
})
export class AddTagDialogComponent {

    error: string;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<AddTagDialogComponent>,
        @Inject(forwardRef(() => CustomLabelService)) private labelService: CustomLabelService,
        @Inject(forwardRef(() => LocalizationPipe)) private localizationPipe: LocalizationPipe,
        @Inject(forwardRef(() => MatSnackBar)) private snackBar: MatSnackBar,
        @Inject(forwardRef(() => TagService)) private tagService: TagService,
        @Inject(forwardRef(() => ContextService)) private contextService: ContextService
    ) { }

    performAdd(tagName): void {
        this.tagService.saveTag({ name: tagName })
            .then(_ => this.contextService.initTags())
            .then(() => this.labelService.getCustomLabel('tagCreatedProperty'))
            .then(message => this.snackBar.open(`${tagName} ${this.localizationPipe.transform(message)}`, '', {
                duration: 5000,
                horizontalPosition: 'start',
                verticalPosition: 'bottom',
                panelClass: 'notification-info'
            }))
            .then(() => this.dialogRef.close(true))
            .catch(err => this.error = ErrorUtility.getMessage(err, ErrorMessages.GENERIC_ERROR));
    }
}